import { theme } from '@go-shippit/shippit-ui-library';
// @ts-ignore
import logo from '../../assets/images/new_shippit_logo.svg';

export const mockReturnBrandingResponse = {
  returns_branding: {
    header_background_colour: theme.colors.primary[500],
    button_background_colour: theme.colors.primary[500],
    accent_colour: theme.colors.primary[500],
    button_text_colour: '#FFFFFF',
    logo_alignment: 'center',
    header_logo: logo,
    favicon: logo,
    iframe: false,
  },
};
